<template>
  <Day day="04.12.2025">
    <div slot="page-content">
      <h3>Was ein schöner Boden</h3>
      <p>
        <img src="@/assets/day4.jpeg"/>
      </p>
    </div>
  </Day>
</template>

<script>
import Day from '../Day.vue'

export default {
  name: 'Day04',
  components: {
    Day
  }
}
</script>
